import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { saveLastLocation } from '../utils/sessionContinuity';

/**
 * Hook to automatically save the current location for session continuity
 * Should be used in the main App component or router
 */
export const useSessionContinuity = () => {
  const location = useLocation();

  useEffect(() => {
    // Only run on client side
    if (typeof window === 'undefined') return;

    // Save the current location whenever it changes
    // Exclude login-related routes and auth pages
    const excludedPaths = ['/login', '/forgot-password', '/reset-password', '/register'];

    if (!excludedPaths.some(path => location.pathname.startsWith(path))) {
      saveLastLocation(location.pathname, location.search);
    }
  }, [location.pathname, location.search]);
};